// app/javascript/projects/components/TeamModalSubscription.jsx

import React from 'react';
import AccountSingleButton from './AccountSingleButton'
import { useSubscription } from '../../hooks/subscriptions/queries';
import { useAddSeat } from '../../hooks/subscriptions/mutations';
import { getSubscriptionInterval } from '../../utils/subscriptionUtils';

function TeamModalSubscription({ pageData, navigateToPage, PAGES }) {
  const { data: subscription } = useSubscription();
  const addSeatMutation = useAddSeat();
  
  const email = pageData?.email;

  const handleAddSeat = () => {
    if (subscription?.id && email) {
      addSeatMutation.mutate(
        { subscriptionId: subscription.id, email },
        {
          onSuccess: () => {
            // Navigate back to main page on success
            navigateToPage(PAGES.MAIN_PAGE);
          }
        }
      );
    }
  };

  // Check if error is a 409 conflict
  const getErrorMessage = () => {
    if (!addSeatMutation.error) return null;
    
    // Check for 409 status in the error response
    if (addSeatMutation.error?.response?.status === 409) {
      return {
        error: true,
        message: "The user you are trying to invite already has an active Delve subscription."
      };
    }
    
    return {
      error: true,
      message: "Something went wrong, please refresh and try again."
    };
  };

  return (
    <AccountSingleButton
      error={getErrorMessage()}
      onClick={handleAddSeat}
      loading={addSeatMutation.isPending}
      header="Review the details"
      body={<p>
        Your team member will be able to start using Delve immediately. You are increasing your subscription by 1 team member.
      </p>}
      button="Confirm Subscription Change"
      disclaimer={`By adding an additional team member, you agree to be charged
        a prorated amount for this ${getSubscriptionInterval(subscription)} starting on your next billing cycle,
        and to automatically be charged each ${getSubscriptionInterval(subscription)} with your updated number of team
        members until you cancel.`}
    />
  );
}

export default TeamModalSubscription;